import { type Event } from '../receipt.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

// Pulls a readable message off either a server `errorMessage` or a thrown actor error.
export const getEventErrorMessage = (event: Event): string | undefined => {
  if ('output' in event) {
    const { output } = event as { output?: { errorMessage?: string | null } };

    return output?.errorMessage ?? undefined;
  }

  if ('error' in event) {
    return toErrorMessage((event as { error?: unknown }).error);
  }

  return undefined;
};

export const toErrorMessage = (raw: unknown): string | undefined => {
  if (raw == null) return undefined;

  if (raw instanceof Error) return raw.message;

  if (typeof raw === 'string') return raw;

  if (typeof raw === 'object' && 'message' in raw && typeof raw.message === 'string') {
    return raw.message;
  }

  try {
    return JSON.stringify(raw);
  } catch {
    return undefined; // circular reference
  }
};
